export default __webpack_public_path__ + "static/media/Deo-Glamour.50a6f00c.jpg";